import { observer } from 'mobx-react'

import { useWinninAuthRouterPermissionsModel } from './winnin-auth-router-permissions.model'
import type { TWinninAuthRouterPermissionsProps } from './winnin-auth-router-permissions.types'
import { WinninAuthRouterPermissionsView } from './winnin-auth-router-permissions.view'

export const WinninAuthRouterPermissions = observer((props: TWinninAuthRouterPermissionsProps) => {
  const model = useWinninAuthRouterPermissionsModel()
  return <WinninAuthRouterPermissionsView {...model} {...props} />
})
